// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2fCi9","footer":"ModalCreateQualiphyProcedure_footer__3ij1Z","additionData":"ModalCreateQualiphyProcedure_additionData__1DWw1"};